module.exports = __webpack_public_path__ + "static/img/bg3.052fd23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/bg3.png
// module id = u+KJ
// module chunks = 0